stimulusApp.register(
  "review-translation",
  class extends Stimulus.Controller {
    static values = {
      translated: Boolean,
      translateText: { type: String, default: null },
      originalText: { type: String, default: null },
    }

    translate(event) {
      this.translatedValue = !this.translatedValue

      if (this.translatedValue) {
        if (this.hasOriginalTextValue) {
          this.element.querySelector(".reviews-i--translate span").innerText =
            this.originalTextValue
        }
        this.element.setAttribute(
          "dir",
          this.element
            .querySelector(".reviews-i--headline[data-state='translated']")
            .getAttribute("dir"),
        )
      } else {
        if (this.hasTranslateTextValue) {
          this.element.querySelector(".reviews-i--translate span").innerText =
            this.translateTextValue
        }
        this.element.setAttribute(
          "dir",
          this.element
            .querySelector(".reviews-i--headline[data-state='original']")
            .getAttribute("dir"),
        )
      }
    }
  },
)
